import { DashboardStateModel } from '~backoffice/app/~shared/models/store.models';
import { SuperSetDashboard } from '~core/models/core.models';
import { TimeRangeObject } from '~core/models/shared.models';

export class ResetState {
  static readonly type = '[Dashboard] Reset State';
  constructor(public data?: Partial<DashboardStateModel>) {}
}

export class LoadAvailableDashboard {
  static readonly type = '[Dashboard] Load Dashboard Data';
}

export class SelectDashboard {
  static readonly type = '[Dashboard] Select Dashboard';
  constructor(public payload: SuperSetDashboard) {}
}

export class LoadDashboardEmbedGuestToken {
  static readonly type = '[Dashboard] Load Dashboard Embed Guest Token';
}

export class RefreshDashboardEmbedGuestToken {
  static readonly type = '[Dashboard] Refresh Dashboard Embed Guest Token';
}

export class SetResourceTimeRange {
  static readonly type = '[Dashboard] Set Resource Time Range';
  constructor(public payload: TimeRangeObject | null) {}
}
